document.addEventListener('DOMContentLoaded', function () {
  // tabs (within each product-tabs section)
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    wrap.querySelectorAll('.tab').forEach(function (t) {
      t.addEventListener('click', function () {
        var cur = wrap.querySelector('.tab.active');
        if (cur) cur.classList.remove('active');
        t.classList.add('active');

        // toggle product panels: show matching [data-tab-panel], hide others
        var idx = t.getAttribute('data-tab');
        if (idx === null) return;
        var sec = wrap.nextElementSibling;
        while (sec && !sec.querySelector) { sec = sec.nextElementSibling; }
        var scope = sec && sec.querySelector('[data-tab-panel]') ? sec : document;
        scope.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-tab-panel') !== idx;
        });
      });
    });
  });

  // carousel arrows
  document.querySelectorAll('.cbtn').forEach(function (b) {
    b.addEventListener('click', function () {
      var rail = document.getElementById(b.getAttribute('data-rail'));
      if (!rail) return;
      var amt = rail.clientWidth * 0.7 * (b.classList.contains('next') ? 1 : -1);
      rail.scrollBy({ left: amt, behavior: 'smooth' });
    });
  });

  // mobile drawer
  var drawer = document.getElementById('site-drawer');
  var overlay = document.getElementById('site-overlay');
  var burger = document.getElementById('site-burger');
  var closeb = document.getElementById('drawer-close');
  function open() { if (drawer) drawer.classList.add('open'); if (overlay) overlay.classList.add('open'); }
  function close() { if (drawer) drawer.classList.remove('open'); if (overlay) overlay.classList.remove('open'); }
  if (burger) burger.addEventListener('click', open);
  if (closeb) closeb.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  // countdown bars
  document.querySelectorAll('[data-countdown]').forEach(function (bar) {
    var t = parseInt(bar.getAttribute('data-countdown'), 10) || 0;
    var dd = bar.querySelector('.dd'), hh = bar.querySelector('.hh'),
        mm = bar.querySelector('.mm'), ss = bar.querySelector('.ss');
    function pad(n) { return String(n).padStart(2, '0'); }
    setInterval(function () {
      if (t <= 0) return; t--;
      if (dd) dd.textContent = pad(Math.floor(t / 86400));
      if (hh) hh.textContent = pad(Math.floor((t % 86400) / 3600));
      if (mm) mm.textContent = pad(Math.floor((t % 3600) / 60));
      if (ss) ss.textContent = pad(t % 60);
    }, 1000);
  });

  // close announcement
  document.querySelectorAll('[data-close-announce]').forEach(function (x) {
    x.addEventListener('click', function () { x.closest('.sale-bar').style.display = 'none'; });
  });

  // hero slideshow
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;
    var i = 0;
    var delay = (parseInt(hero.getAttribute('data-autoplay'), 10) || 6) * 1000;
    var timer;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
    }
    function start() { timer = setInterval(function () { show(i + 1); }, delay); }
    function reset() { clearInterval(timer); start(); }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-hero-dot'), 10)); reset(); });
    });
    start();
  });

  // email popup
  var popup = document.getElementById('email-popup');
  if (popup) {
    var seen = false;
    try { seen = sessionStorage.getItem('popup-seen') === '1'; } catch (e) {}
    function closePopup() {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem('popup-seen', '1'); } catch (e) {}
    }
    popup.querySelectorAll('[data-popup-close]').forEach(function (b) {
      b.addEventListener('click', closePopup);
    });
    var success = popup.querySelector('.popup-success');
    if (success) {
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
    } else if (!seen) {
      var delay = (parseInt(popup.getAttribute('data-popup-delay'), 10) || 4) * 1000;
      setTimeout(function () {
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
      }, delay);
    }
  }

  // order tracking form
  document.querySelectorAll('[data-track-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[name="tracking"]');
      var num = input ? input.value.trim() : '';
      if (!num) return;
      window.open('https://parcelsapp.com/en/tracking/' + encodeURIComponent(num), '_blank', 'noopener');
    });
  });
});

/* ===== Cart AJAX qty/remove (progressive; falls back to GET links) ===== */
(function(){
  var form=document.querySelector('.cart-form'); if(!form) return;
  function change(key,qty){return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();});}
  form.addEventListener('click',function(e){
    var a=e.target.closest('.qty-btn,.cart-remove'); if(!a) return; e.preventDefault();
    var item=a.closest('.cart-item'), key=item.getAttribute('data-key'), qty;
    if(a.classList.contains('cart-remove')){qty=0;}
    else{var input=item.querySelector('.qty-input'),cur=parseInt(input.value||'1',10);qty=(a.getAttribute('aria-label')||'').indexOf('Increase')>-1?cur+1:cur-1;}
    if(qty<0)qty=0; change(key,qty).then(function(){location.reload();});
  });
  form.addEventListener('change',function(e){
    var input=e.target.closest('.qty-input'); if(!input) return;
    var item=input.closest('.cart-item'),key=item.getAttribute('data-key'),qty=parseInt(input.value||'0',10);
    if(isNaN(qty)||qty<0)qty=0; change(key,qty).then(function(){location.reload();});
  });
})();